// import { Entity, EntityAspect, EntityType, EntityManager, NavigationProperty, DataProperty } from 'breeze-client';
// import _ from 'lodash';
// import moment from 'moment';
// import { UtilityService } from './utility.service';
// import { environment } from 'environments/environment';
// import list from 'devextreme/ui/list';

export type Guid = string;

export class Entities {
    static lookups: any;
}
//     static registerEntityTypes(manager: EntityManager) {
//         // tslint:disable: no-use-before-declare
//         manager.metadataStore.registerEntityTypeCtor('Message', Message);
//         manager.metadataStore.registerEntityTypeCtor('MessageAttachment', MessageAttachment);
//         manager.metadataStore.registerEntityTypeCtor('CalendarEvent', CalendarEvent);
//         manager.metadataStore.registerEntityTypeCtor('CalendarEventType', CalendarEventType);
//         manager.metadataStore.registerEntityTypeCtor('ContributionAccountAttachment', ContributionAccountAttachment);
//         manager.metadataStore.registerEntityTypeCtor('ContributionBatch', ContributionBatch);
//         manager.metadataStore.registerEntityTypeCtor('Contribution', Contribution);
//         manager.metadataStore.registerEntityTypeCtor('CloverAccount', CloverAccount);
//         manager.metadataStore.registerEntityTypeCtor('Family', Family);
//         manager.metadataStore.registerEntityTypeCtor('Person', Person);
//         manager.metadataStore.registerEntityTypeCtor('Photo', Photo);
//         manager.metadataStore.registerEntityTypeCtor('Pledge', Pledge);
//         manager.metadataStore.registerEntityTypeCtor('PledgeLine', PledgeLine);
//         manager.metadataStore.registerEntityTypeCtor('Visit', Visit);
//         manager.metadataStore.registerEntityTypeCtor('Involvement', Involvement);
//         manager.metadataStore.registerEntityTypeCtor('InvolvementSkill', InvolvementSkill);
//         manager.metadataStore.registerEntityTypeCtor('BackgroundCheck', BackgroundCheck);
//         manager.metadataStore.registerEntityTypeCtor('CommitteeAttachment', CommitteeAttachment);
//         manager.metadataStore.registerEntityTypeCtor('CommitteeAttachmentEmail', CommitteeAttachmentEmail);
//         manager.metadataStore.registerEntityTypeCtor('CommitteeAttachmentEmailLink', CommitteeAttachmentEmailLink);
//         manager.metadataStore.registerEntityTypeCtor('CommitteeMember', CommitteeMember);
//         manager.metadataStore.registerEntityTypeCtor('Nomination', Nomination);
//         manager.metadataStore.registerEntityTypeCtor('NominationAssignment', NominationAssignment);
//         manager.metadataStore.registerEntityTypeCtor('Proposal', Proposal);
//         manager.metadataStore.registerEntityTypeCtor('BankTransaction', BankTransaction);
//         manager.metadataStore.registerEntityTypeCtor('Log', Log);
//         manager.metadataStore.registerEntityTypeCtor('User', User);
//         // tslint:enable: no-use-before-declare
//     }
// }

// class BaseEntity implements Entity {
//     entityAspect: EntityAspect;
//     entityType: EntityType;
// }

// class BaseGuidEntity extends BaseEntity {
//     id: Guid;
// }

// class BaseIntEntity extends BaseEntity {
//     id: number;
// }

// export class Person extends BaseIntEntity {
//     familyId: number;
//     family: Family;
//     title: any;
//     suffix: any;
//     firstName: any;
//     middleName: any;
//     lastName: any;
//     preferredName: any;
//     isActive: boolean;
//     address1: any;
//     address2: any;
//     city: any;
//     state: any;
//     zip: any;
//     email: string;
//     homePhone: string;
//     cellPhone: string;
//     birthDate: Date;
//     baptizedDate: Date;
//     professionDate: Date;
//     joinedDate: Date;
//     graduationDate: Date;
//     weddingDate: Date;
//     deceasedDate: Date;
//     lastSafeChurchTrained: Date;
//     departureDate: Date;
//     personInterests: any[];
//     interestsLastUpdated: Date;
//     useFamilyAddress: boolean;
//     includeInDirectory: boolean;
//     relationshipId: number;
//     relationship: any;
//     isBaptized: boolean;
//     envelopeNumber: string;
//     sex: string;
//     personStatusId: number;
//     schoolId: number;
//     includeForGiving: boolean;

//     // get birthDateLocal() {
//     //     return UtilityService.utcToLocal(this.birthDate, true);
//     // }
//     // set birthDateLocal(value) {
//     //     this.birthDate = UtilityService.localToUtc(value);
//     // }

//     // get baptizedDateLocal() {
//     //     return UtilityService.utcToLocal(this.baptizedDate, true);
//     // }
//     // set baptizedDateLocal(value) {
//     //     this.baptizedDate = UtilityService.localToUtc(value);
//     // }

//     // get professionDateLocal() {
//     //     return UtilityService.utcToLocal(this.professionDate, true);
//     // }
//     // set professionDateLocal(value) {
//     //     this.professionDate = UtilityService.localToUtc(value);
//     // }

//     // get joinedDateLocal() {
//     //     return UtilityService.utcToLocal(this.joinedDate, true);
//     // }
//     // set joinedDateLocal(value) {
//     //     this.joinedDate = UtilityService.localToUtc(value);
//     // }

//     // get graduationDateLocal() {
//     //     return UtilityService.utcToLocal(this.graduationDate, true);
//     // }
//     // set graduationDateLocal(value) {
//     //     this.graduationDate = UtilityService.localToUtc(value);
//     // }

//     // get weddingDateLocal() {
//     //     return UtilityService.utcToLocal(this.weddingDate, true);
//     // }
//     // set weddingDateLocal(value) {
//     //     this.weddingDate = UtilityService.localToUtc(value);
//     // }
//     // get deceasedDateLocal() {
//     //     return UtilityService.utcToLocal(this.deceasedDate, true);
//     // }
//     // set deceasedDateLocal(value) {
//     //     this.deceasedDate = UtilityService.localToUtc(value);
//     // }
//     // get departureDateLocal() {
//     //     return UtilityService.utcToLocal(this.departureDate, true);
//     // }
//     // set departureDateLocal(value) {
//     //     this.departureDate = UtilityService.localToUtc(value);
//     // }

//     // get lastSafeChurchTrainedLocal() {
//     //     return UtilityService.utcToLocal(this.lastSafeChurchTrained, true);
//     // }
//     // set lastSafeChurchTrainedLocal(value) {
//     //     this.lastSafeChurchTrained = UtilityService.localToUtc(value);
//     // }

//     // get displayName() {
//     //     return `${this.firstName || ''} ${this.lastName || ''}`;
//     // }

//     // get displayNameLastFirst() {
//     //     return `${this.lastName + ',' || ''} ${this.firstName || ''}`;
//     // }

//     // get displayAddress() {
//     //     const address = this.useFamilyAddress
//     //         ? this.family && this.family.displayAddress
//     //         : `${this.address1 || ''} ${this.address2 || ''} ${this.city || ''} ${this.state || ''} ${this.zip || ''}`;
//     //     return address;
//     // }

//     // get age() {
//     //     if (!this.birthDate) return null;
//     //     return moment().diff(moment(this.birthDate), 'year');
//     // }

//     // getPersonInfo() {
//     //     return {
//     //         name: this.firstName + ' ' + this.lastName + (this.envelopeNumber ? ' - ' + this.envelopeNumber : ''),
//     //         id: this.id,
//     //         envelope: this.envelopeNumber,
//     //         sex: this.sex,
//     //     };
//     // }
// }

// export class Log extends BaseIntEntity {
// }


// export class Family extends BaseIntEntity {
//     // static Statuses = {
//     //     Visitor: 5,
//     //     ProfessingMember: 6,
//     //     Deceased: 7,
//     //     InActiveMember: 61,
//     //     RegularAttender: 62,
//     //     NonMember: 223,
//     //     NonFamily: 224,
//     //     Baptised: 227,
//     //     ProgramParent: 277,
//     //     ProgramAttender: 280,
//     //     Family: 293,
//     //     ProgramGrandparent: 321,
//     //     ProgramGuardian: 378,
//     //     Transferred: 63,
//     //     Lapsed: 268,
//     //     Resigned: 677,
//     // };
//     name: string;
//     created: Date;
//     isActive: boolean;
//     includeInDirectory: boolean;
//     homePhone: string;
//     address1: string;
//     address2: string;
//     city: string;
//     state: string;
//     zip: string;
//     country: string;
//     phone: string;
//     familyStatusId: number;
//     members: Person[];
//     photos: Photo[];

//     // get displayAddress() {
//     //     const address = `${this.address1 || ''} ${this.address2 || ''} ${this.city || ''} ${this.state || ''} ${this.zip || ''}`;
//     //     return address;
//     // }

//     // updateName() {
//     //     if (!this.members) return;

//     //     let name = 'Blank Family';

//     //     if (this.members.length > 0) {
//     //         const head = _(this.members).find((m: Person) => !!m.relationship && m.relationship.name === 'Head of Household');
//     //         const spouse = _(this.members).find((m: Person) => !!m.relationship && m.relationship.name === 'Spouse');
//     //         name =
//     //             head?.deceasedDate && (!spouse || (spouse && spouse?.deceasedDate))
//     //                 ? `Deceased Family, ${head.lastName}, ${head.firstName}`
//     //                 : head && !head.deceasedDate
//     //                 ? `${head.lastName}, ${head.firstName} ${
//     //                       spouse && !spouse.deceasedDate ? `& ${spouse.firstName}${spouse.lastName !== head.lastName ? ' ' + spouse.lastName : ''}` : ''
//     //                   }`
//     //                 : spouse && !spouse.deceasedDate
//     //                 ? `${spouse.lastName}, ${spouse.firstName}`
//     //                 : 'New Family';
//     //     }

//     //     if (this.name !== name) this.name = name;
//     // }
//     // get headOfHousehold() {
//     //     const head = _(this.members).find((m: Person) => !!m.relationship && m.relationship.name === 'Head of Household');
//     //     return head;
//     // }
// }

// export class Photo extends BaseIntEntity {
//     fileName: string;
//     isDirectoryPhoto;
//     url: string;
//     thumbnailUrl: string;
//     approved: Date;
// }

// export class Message extends BaseGuidEntity {
//     subject: string;
//     body: string;
//     created: Date;
//     sent: Date;
//     status: number;
//     toGroupId: Guid;
//     toGroup: any;
//     attachments: MessageAttachment[];
//     deleted: Date;
//     fromUserId: number;
//     privateEmail: boolean;
// }

// export class MessageAttachment extends BaseGuidEntity {
//     messageId: Guid;
//     message: Message;
//     name: string;
//     fileName: string;

//     // get url() {
//     //     return `https://peccerium.blob.core.windows.net/neland/MessageAttachments/${this.fileName}`;
//     // }
//     // get urlGraafschap() {
//     //     return `https://peccerium.blob.core.windows.net/graafschap/MessageAttachments/${this.fileName}`;
//     // }
// }

// export class TextGroupLink extends BaseIntEntity {
//     messageId: Guid;
//     message: any;
//     toGroupId: Guid;
//     toGroup: any;
// }
// export class TextMessage extends BaseGuidEntity {
//     body: string;
//     created: Date;
//     sent: Date;
//     status: number;
// }

// export class TextMessageSents extends BaseGuidEntity {
//     messageId: Guid;
//     message: TextMessage;
//     personId: number;
//     person: Person;
// }

// export class ContributionBatch extends BaseIntEntity {
//     date: Date;
//     name: any;
//     specialAccountId: number;
//     statusId: number;
//     note: any;
//     created: Date;
//     createdBy: any;
//     bagNumber: number;
//     deposited: Date;
//     contributions: Contribution[];

//     // get batchTotalAmount() {
//     //     let total = 0;
//     //     if (!!this.contributions) {
//     //         this.contributions.forEach((contribution) => {
//     //             if (!!contribution.lines) {
//     //                 contribution.lines.forEach((line) => {
//     //                     total += line.amount;
//     //                 });
//     //             }
//     //         });
//     //     }

//     //     return total;
//     // }
// }

// export class ContributionBatchNote extends BaseIntEntity {
//     batchId: number;
//     created: Date;
//     createdBy: string;
// }

// export class Contribution extends BaseIntEntity {
//     batchId: number;
//     batch: ContributionBatch;
//     typeId: number;
//     checkNumber: string;
//     personId: number;
//     person: Person;
//     rmdContribution: boolean;
//     note: string;
//     lines: ContributionLine[];
//     cashCounts: any;

//     // get totalAmount() {
//     //     if (this.lines && this.lines.length > 0) {
//     //         let total = 0;
//     //         this.lines.forEach((line) => {
//     //             total += line.amount;
//     //         });
//     //         return Math.round(total * 100) / 100;
//     //     } else return 0;
//     // }
// }

// export class ContributionLine extends BaseIntEntity {
//     contributionId: number;
//     contribution: Contribution;
//     accountId: number;
//     account: any;
//     amount: number;

//     // not mapped
//     // allowSelect: boolean;
// }

// export class CloverAccount extends BaseIntEntity {
//     cloverName: string;
//     contributionAccountId: number;
//     batchName: string;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     deletedBy: string;
// }

// export class CalendarEvent extends BaseIntEntity {
//     typeId: number;
//     type: CalendarEventType;
//     eventDate: Date;
//     startTime: Date;
//     endTime: Date;
//     privateEvent: boolean;
//     name: string;
//     description: string;
//     location: string;
//     officeInformation: string;
//     contactPerson: string;
//     price: number;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     deletedBy: string;
// }
// export class CalendarEventType extends BaseIntEntity {
//     name: string;
//     displayOrder: number;
//     deleted: Date;
//     deletedBy: string;
// }
// export class Interest extends BaseIntEntity {
//     name: string;
//     interestCategory: InterestCategory;
//     interestCategoryId: number;
// }

// export class InterestCategory extends BaseIntEntity {
//     name: string;
// }

// export class BackgroundCheck extends BaseGuidEntity {
//     personId: number;
//     person: Person;
//     submitted?: Date;
//     received?: Date;
//     cleared?: boolean;

//     // get submittedLocal() {
//     //     return UtilityService.utcToLocal(this.submitted, false);
//     // }
//     // set submittedLocal(value) {
//     //     this.submitted = UtilityService.localToUtc(value);
//     // }

//     // get receivedLocal() {
//     //     return UtilityService.utcToLocal(this.received, false);
//     // }
//     // set receivedLocal(value) {
//     //     this.received = UtilityService.localToUtc(value);
//     // }
// }
// export class Involvement extends BaseIntEntity {
//     when: Date;
//     personId: number;
//     skillId: number;

//     // get whenLocal() {
//     //     return UtilityService.utcToLocal(this.when, false);
//     // }
//     // set whenLocal(value) {
//     //     this.when = UtilityService.localToUtc(value);
//     // }
// }

// export class InvolvementSkill extends BaseIntEntity {
//     name: string;
//     description: string;
// }

// export class Pledge extends BaseGuidEntity {
//     personId: number;
//     person: Person;
//     lines: PledgeLine[];
//     date: Date;

//     // get amount() {
//     //     return _(this.lines).sumBy((l) => l.amount || 0);
//     // }
// }

// export class PledgeLine extends BaseGuidEntity {
//     expectedDate: Date;
//     amount: number;

//     // get sortValue() {
//     //     return this.expectedDate || new Date(2999, 1, 1); //  moment('1/1/2999').toDate()
//     // }
// }

// export class Visit extends BaseIntEntity {
//     personId: number;
//     person: Person;
//     date: Date;
// }

// export class OfferingSchedule extends BaseIntEntity {
//     batchId: number;
//     batch: ContributionBatch;
//     specialAccountId: number;
//     offeringDate: Date;
//     aMOffering: boolean;
//     pMOffering: boolean;
//     note: string;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
// }

// export class Committee extends BaseIntEntity {
//     // static Committees = {
//     //     FullCouncil: 1,
//     //     Deacons: 2,
//     //     ShepherdingElders: 3,
//     //     ExecutiveElders: 4,
//     //     ExecutiveCommittee: 5,
//     // };
//     name: string;
//     displayOrder: number;
//     deleted: Date;
// }

// export class ContributionAccountAttachment extends BaseIntEntity {
//     contributionAccountId: number;
//     name: string;
//     filename: string;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     deletedBy: string;
// }

// export class CommitteeAttachment extends BaseIntEntity {
//     // static Types = {
//     //     Document: 1,
//     //     Minutes: 2,
//     //     Agenda: 3,
//     // };
//     committeeId: number;
//     committee: Committee;
//     proposalId: number;
//     name: string;
//     filename: string;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     deletedBy: string;
//     typeId: number;
//     agendaText: string;
//     committeeAttachmentReviews: CommitteeAttachmentReview[];

//     // get typeName() {
//     //     return this.typeId === 1 ? 'Document' : 'Minutes'
//     // }
// }
// export class CommitteeAttachmentEmail extends BaseIntEntity {
//     committeeId: number;
//     committee: Committee;
//     sentTo: string;
//     created: Date;
//     createdBy: string;
//     sent: Date;
//     deleted: Date;
//     deletedBy: string;
// }
// export class CommitteeAttachmentEmailLink extends BaseIntEntity {
//     emailId: number;
//     email: CommitteeAttachmentEmail;
//     attachmentId: number;
//     attachment: CommitteeAttachment;
// }

// export class CommitteeAttachmentReview extends BaseIntEntity {
//     committeeAttachmentId: number;
//     committeeAttachment: CommitteeAttachment;
//     person: Person;
//     personId: number;
//     sent: Date;
//     viewed: Date;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     deletedBy: string;
// }
// export class CommitteeMember extends BaseIntEntity {
//     committee: Committee;
//     committeeId: number;
//     person: Person;
//     personId: number;
//     chair: boolean;
//     clerk: boolean;
//     startDate: Date;
//     endDate: Date;

//     // get term() {
//     //     return `${moment(this.startDate).year()}-${!!this.endDate ? moment(this.endDate).year() : ' Est. ' + moment(this.startDate).add(3, 'years').year()}`
//     // }
// }
// export class Nomination extends BaseIntEntity {
//     person: Person;
//     personId: number;
//     role: string;
//     note: string;
//     confirmed: Date;
//     accepted: Date;
//     declined: Date;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     closed: Date;
// }

// export class NominationAssignment extends BaseIntEntity {
//     person: Person;
//     personId: number;
//     role: string;
//     note: string;
//     confirmed: Date;
//     accepted: Date;
//     declined: Date;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     closed: Date;

//     // get status() {
//     //     return `${this.accepted ? 'Accepted' : this.declined ? 'Declined' : 'Pending'}`;
//     // }
// }

// export class NominationVote extends BaseIntEntity {
//     personId: number;
//     code: Guid;
//     voted: Date;
//     viewed: Date;
//     sent: Date;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
// }

// export class Proposal extends BaseIntEntity {
//     title: string;
//     description: number;
//     fromCommittee: string;
//     toCommittee: string;
//     approved: Date;
//     declined: Date;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     emailed: Date;
//     allowDiscussion: boolean;
//     proposalVotes: PropsalVote[];
//     proposalDiscussions: any[];

//     // get voteCount() {
//     //     let count = 0;
//     //     if (this.proposalVotes && this.proposalVotes.length > 0) {
//     //         this.proposalVotes.forEach((vote) => {
//     //             if (vote.yesVote || vote.noVote) count++;
//     //         });
//     //     }
//     //     return count;
//     // }
// }
// export class PropsalVote extends BaseIntEntity {
//     proposalId: number;
//     proposal: Proposal;
//     userId: number;
//     yesVote: boolean;
//     noVote: boolean;
//     created: Date;
//     createdBy: string;
//     deleted: Date;
//     personId: number;
//     code: Guid;
//     voted: Date;
//     viewed: Date;
//     sent: Date;
// }

// export class ProposalDiscussion extends BaseIntEntity {
//     proposalId: number;
//     proposal: Proposal;
//     personId: number;
//     note: string;
//     created: Date;
//     deleted: Date;
// }

// export class BankTransaction extends BaseIntEntity {
//     bankTransactionTypeId: number;
//     accountNumber: string;
//     postDate: Date;
//     check: string;
//     description: string;
//     debit: number;
//     credit: number;
//     status: string;
//     balance: number;
//     created: Date;
//     deleted: Date;
//     assignedMonth: Date;
//     processed: Date;
//     claimed: Date;
//     claimedBy: string;
//     onlineContributions: OnlineContribution[];

//     // get contributionList() {
//     //     let list = null;
//     //     if (!!this.onlineContributions && this.onlineContributions.length > 0) {
//     //         list = 'Linked';
//     //         // this.onlineContributions.forEach(x => {
//     //         //     list.push(x.id);
//     //         // });
//     //     }

//     //     // return list.join('; ');
//     //     return list;
//     // }
// }
// export class BankTransactionType extends BaseIntEntity {
//     name: string;
//     displayOrder: number;
// }

// export class OnlineContribution extends BaseIntEntity {
//     bankAmountId: number;
//     bankAmount: BankTransaction;
//     donationDate: Date;
//     donorName: string;
//     grossGift: number;
//     batchId: number;
//     fund: string;
//     paymentSource: string;
//     donorId: number;
//     notes: string;
//     recurringGift: string;
//     frequency: string;
//     donorCoversFees: string;
//     contributionId: number;
//     contribution: Contribution;
//     created: Date;
//     deleted: Date;
//     personId: number;
//     assignedMonth: Date;
//     currentMonth: boolean;
//     nextMonth: boolean;
//     processed: Date;
// }

// export class User extends BaseIntEntity {
//     // get displayRoles() {
//     //     let roles: string[] = [];
//     //     if (!!this.userRoles) {
//     //         const userRoles = _(this.userRoles).orderBy('role.name');
//     //         userRoles.forEach((x) => {
//     //             roles.push(x.role.name);
//     //         });
//     //     }
//     //     return roles.join(' ---- ');
//     // }

//     id: number;
//     inactive: boolean;
//     email: string;
//     name: string;
//     password: string;
//     userName: string;
//     userRoles: UserRole[];
//     personId?: number;
//     person: Person;

//     // //TODO: remove
//     // Code: any;
//     // jwtToken: string;
// }

// export class UserRole extends BaseIntEntity {
//     id: number;
//     userId: number;
//     user: User;
//     roleId: number;
//     role: Role;
// }

// export class Role extends BaseIntEntity {
//     id: number;
//     name: string;
// }
